// ----- Phase 5.X-publish-governance — Modal shell shared styles -----
//
// Split out of `modalShell.tsx` so React Fast Refresh doesn't trip
// the `react-refresh/only-export-components` rule (which requires
// component files to export only components). The constants stay
// here, the `<ModalShell />` component stays in the .tsx file.

import type { CSSProperties } from 'react';

export const overlayStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

export const modalStyle: CSSProperties = {
  background: 'var(--bg)',
  color: 'var(--text)',
  padding: 20,
  borderRadius: 8,
  maxWidth: 540,
  width: '90vw',
  maxHeight: '80vh',
  overflow: 'auto',
  boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
};

export const primaryButtonStyle: CSSProperties = {
  background: 'var(--accent)',
  color: 'var(--bg)',
  border: 'none',
  borderRadius: 6,
  padding: '8px 16px',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
};

export const secondaryButtonStyle: CSSProperties = {
  background: 'none',
  color: 'var(--text)',
  border: '1px solid var(--border)',
  borderRadius: 6,
  padding: '6px 12px',
  fontSize: 12,
  cursor: 'pointer',
};

export const dangerButtonStyle: CSSProperties = {
  ...primaryButtonStyle,
  background: 'var(--danger, #b91c1c)',
};

export const buttonRowStyle: CSSProperties = {
  display: 'flex',
  gap: 8,
  justifyContent: 'flex-end',
};
